import React, { useMemo, useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import SearchIcon from "@material-ui/icons/Search";
import { InputBase } from "@material-ui/core";
import "./FacialDeviceChecklist.css";

export interface FacialDevice {
  id: string;
  label: string;
}

type FacialDeviceChecklistProps = {
  devices: FacialDevice[];
  value: string[];
  onChange: (ids: string[]) => void;
  searchPlaceholder?: string;
  disabled?: boolean;
};

const FacialDeviceChecklist = ({
  devices,
  value,
  onChange,
  searchPlaceholder = "Buscar dispositivo",
  disabled = false,
}: FacialDeviceChecklistProps) => {
  const [searchText, setSearchText] = useState("");

  const filteredDevices = useMemo(
    () => devices.filter((d) => d.label.toLowerCase().includes(searchText.toLowerCase())),
    [devices, searchText]
  );

  const toggleDevice = (deviceId: string) => {
    if (disabled) return;
    const isSelected = value.includes(deviceId);
    const nextValue = isSelected ? value.filter((id) => id !== deviceId) : [...value, deviceId];
    onChange(nextValue);
  };

  return (
    <div className="facialDeviceChecklist">
      <div className="facialDeviceChecklistSearch">
        <SearchIcon className="facialDeviceChecklistSearchIcon" />
        <InputBase
          placeholder={searchPlaceholder}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="facialDeviceChecklistSearchInput"
        />
      </div>
      <div className="facialDeviceChecklistList">
        {filteredDevices.length === 0 ? (
          <div className="facialDeviceChecklistEmptyMessage">
            No se encontraron dispositivos
          </div>
        ) : (
          filteredDevices.map((device) => {
            const checked = value.includes(device.id);
            return (
              <div
                key={device.id}
                className={`facialDeviceChecklistRow ${checked ? "checked" : ""} ${disabled ? "disabled" : ""}`}
                onClick={() => toggleDevice(device.id)}
              >
                <span className="facialDeviceChecklistLabel">{device.label}</span>
                <Checkbox
                  checked={checked}
                  disabled={disabled}
                  onChange={() => toggleDevice(device.id)}
                  onClick={(e) => e.stopPropagation()}
                  className="facialDeviceChecklistCheckbox"
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default FacialDeviceChecklist;
